import * as $ from 'jquery';
import { ui } from './ui';
import { Sendform } from '../libs/sendform/sendform2';

$( document ).ready(function() {
    let projectApp = new App();
    projectApp.init();
});

class App{
    constructor(){}
    init() {

        const $body = $('body')

        ui.initLazyLoadImg()

        if ($('.js_modal-location').hasClass('__open')) {
            ui.openPopup('#modal-location')
        }

        if($(window).width() <= 900) {
            ui.addScrollClass('.js_scroll-top')
        }

        if($(window).width() <= 767) {
            ui.setDropdownValue('.js_dropdown-check', '.js_dropdown-lnk', '.js_dropdown-cnt', '.js_dropdown-parent')
        }

        ui.initDefaultSelect('.js_select')

        ui.accordion('.js_accordion-ttl', '.js_accordion-cnt', '__active')
        ui.dropdown('.js_dropdown-lnk', '.js_dropdown-cnt', '.js_dropdown-parent')

        // Popup init
        ui.popupForm('.js_btn-popup')
        ui.closePopup('.js_popup-close')

        ui.initScrollStyle('.js_ui-scroll')

        //Send form
        new Sendform('.js_form-location', {
            msgValEachField: true,
            msgError: 'Sorry, cannot send this form',
            modalOpen: false,
            success: data => {
                let url = JSON.parse(data.response).redirect_to
                window.location.href = url
            }
        })

        ui.initSlider('.js_gallery-slider', {
            dots: false,
            lazyLoad: true,
            margin: 0,
            responsive: {
                768: {
                    items: 3,
                    loop: false,
                    mouseDrag: false,
                    touchDrag: false,
                    nav: false
                },
                320: {
                    items: 1,
                    loop: true,
                    mouseDrag: true,
                    touchDrag: true,
                    nav: true
                }
            }
        })

        // Mobile menu
        $body.on('click', '.js_menu-btn', function(e) {
            e.preventDefault()
            const $cnt = $('.js_menu-cnt')
            $(this).toggleClass('__active')
            if($(this).hasClass('__active')){
                $cnt.addClass('__show-menu')
                $('body').addClass('__overlay')
            } else{
                $cnt.removeClass('__show-menu')
                $('body').removeClass('__overlay')
            }
        })

        // Search
        $body.on('click', '.js_search-btn', function(e) {
            e.preventDefault()
            $(this).closest('.header-wrap-search').addClass('__open')
            $('.js_search-blk').addClass('__active')
        })
        $body.on('click', '.js_close-search', function(e) {
            e.preventDefault()
            $(this).closest('.header-wrap-search').removeClass('__open')
            $(this).closest('.js_search-blk').removeClass('__active')
        })

        $body.on('click', '.js_gallery-lnk', function(e) {
            e.preventDefault()
            $('.js_gallery-lnk').removeClass('__active')
            $(this).addClass('__active')
            const img = $(this).attr('data-img')
            $('.js_gallery-img').attr('src', img)
        })

        $body.on('submit', '.js_search-submit', function(e) {
            const $inp = $(this).find('.js_search-inp')
            const $msg = $(this).find('.js_search-error')
            if ($inp.val().length === 1) {
                $inp.addClass('error')
                $msg.removeClass('__hidden')
                return false
            } else {
                $inp.removeClass('error')
                $msg.addClass('__hidden')
            }
            $('.js_search-value').val($inp.val())
            const $currPage = $('.js_get-url')
            if ($currPage.length) {
                e.preventDefault()
                $currPage.trigger('click')
            }
        })
    }
};
